/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs */

const en_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Focus Mode with a custom Allow List`)
};

const ar_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وضع التركيز العميق مع قائمة السماح المخصصة`)
};

const de_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep-Focus-Modus mit einer benutzerdefinierten Erlaubnisliste`)
};

const es_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de concentración profunda con una lista de permitidos personalizada`)
};

const fr_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode Concentration profonde avec une liste d'autorisations d'applications`)
};

const it_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità Concentrazione intensiva con una Lista delle App consentite personalizzata`)
};

const ja_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可リストのカスタマイズによるディープフォーカスモード`)
};

const ko_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 지정 허용 목록을 이용할 수 있는 딥 포커스 모드`)
};

const pt_br_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo Foco Total com uma Lista de Permissões personalizada`)
};

const ru_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим глубокой фокусировки с настраиваемым списком разрешений`)
};

const th_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โหมดโฟกัสเต็มที่พร้อมด้วยรายการอนุญาตที่กำหนดเอง`)
};

const tr_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel İzin Listesi ile Derin Odaklanma Modu`)
};

const zh_cn_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深度专注模式搭配自定义白名单`)
};

const zh_tw_subscription_exclusive_feature_deep_focus_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深度專注模式搭配自訂允許名單`)
};

/**
* | output |
* | --- |
* | "Deep Focus Mode with a custom Allow List" |
*
* @param {Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_deep_focus_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Deep_Focus_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_deep_focus_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_deep_focus_subtitle(inputs)
});